'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createdContactForChannel = exports.openConversationForNewChannel = exports.endConversation = exports.updateMessageInConversation = exports.addMessageToConversation = exports.incrementPrivateChannelSubscribeCount = exports.startChannelSubscribePoll = exports.subscribeToOpenChannels = exports.requestedVisitorForChannelFailed = exports.receivedVisitorForChannel = exports.requestedVisitorForChannel = exports.receivedConversations = exports.requestedConversationsFailed = exports.incrementUnseenCount = exports.clearUnseenCount = exports.requestedConversations = undefined;
exports.fetchVisitorForChannel = fetchVisitorForChannel;
exports.createContactForChannel = createContactForChannel;
exports.fetchAllConversations = fetchAllConversations;

var _reduxActions = require('redux-actions');

var _ActionTypes = require('conversations-core/constants/ActionTypes');

var _ActionTypes2 = _interopRequireDefault(_ActionTypes);

var _immutable = require('immutable');

var _normalizr = require('normalizr');

var _MessagesClient = require('conversations-core/data/MessagesClient');

var MessagesClient = _interopRequireWildcard(_MessagesClient);

var _fromJSReviver = require('conversations-core/utils/fromJSReviver');

var _fromJSReviver2 = _interopRequireDefault(_fromJSReviver);

var _Schemas = require('conversations-core/data/Schemas');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var requestedConversations = exports.requestedConversations = (0, _reduxActions.createAction)(_ActionTypes2.default.GET_CONVERSATIONS);

var clearUnseenCount = exports.clearUnseenCount = (0, _reduxActions.createAction)(_ActionTypes2.default.CLEAR_UNSEEN_COUNT);

var incrementUnseenCount = exports.incrementUnseenCount = (0, _reduxActions.createAction)(_ActionTypes2.default.INCREMENT_UNSEEN_COUNT);

var requestedConversationsFailed = exports.requestedConversationsFailed = (0, _reduxActions.createAction)(_ActionTypes2.default.GET_CONVERSATIONS_FAILED, function (error) {
  return {
    error: error
  };
});

function assignEntity(output, key, value) {
  output[key] = value;

  if (key === 'visitor') {
    delete output.visitor;
  }
}

var receivedConversations = exports.receivedConversations = (0, _reduxActions.createAction)(_ActionTypes2.default.GET_CONVERSATIONS_SUCCEEDED, function (conversations) {
  return {
    response: (0, _immutable.fromJS)((0, _normalizr.normalize)(conversations, (0, _normalizr.arrayOf)(_Schemas.conversation), { assignEntity: assignEntity }), _fromJSReviver2.default)
  };
});

var requestedVisitorForChannel = exports.requestedVisitorForChannel = (0, _reduxActions.createAction)(_ActionTypes2.default.GET_VISITOR_FOR_CHANNEL);

var receivedVisitorForChannel = exports.receivedVisitorForChannel = (0, _reduxActions.createAction)(_ActionTypes2.default.RECEIVED_VISITOR_FOR_CHANNEL, function (visitor, channel) {
  return { visitor: visitor, channel: channel };
});

var requestedVisitorForChannelFailed = exports.requestedVisitorForChannelFailed = (0, _reduxActions.createAction)(_ActionTypes2.default.RECEIVED_VISITOR_FOR_CHANNEL_FAILED, function (err) {
  return err;
});

var subscribeToOpenChannels = exports.subscribeToOpenChannels = (0, _reduxActions.createAction)(_ActionTypes2.default.SUBSCRIBE_TO_OPEN_CHANNELS);

var startChannelSubscribePoll = exports.startChannelSubscribePoll = (0, _reduxActions.createAction)(_ActionTypes2.default.START_CHANNEL_SUBSCRIBE_POLL);

var incrementPrivateChannelSubscribeCount = exports.incrementPrivateChannelSubscribeCount = (0, _reduxActions.createAction)(_ActionTypes2.default.INCREMENT_CHANNEL_SUBSCRIBE_COUNT);

function fetchVisitorForChannel(channel) {
  return function (dispatch) {
    dispatch(requestedVisitorForChannel());
    return MessagesClient.fetchVisitorForChannel(channel).then(function (visitor) {
      dispatch(receivedVisitorForChannel(visitor, channel));
    }, function (err) {
      dispatch(requestedVisitorForChannelFailed(err));
    }).done();
  };
}

var addMessageToConversation = exports.addMessageToConversation = (0, _reduxActions.createAction)(_ActionTypes2.default.ADD_MESSAGE_TO_CONVERSATION);

var updateMessageInConversation = exports.updateMessageInConversation = (0, _reduxActions.createAction)(_ActionTypes2.default.UPDATE_MESSAGE_IN_CONVERSATION);

var endConversation = exports.endConversation = (0, _reduxActions.createAction)(_ActionTypes2.default.END_CONVERSATION, function (channel) {
  return {
    channel: channel
  };
});

var openConversationForNewChannel = exports.openConversationForNewChannel = (0, _reduxActions.createAction)(_ActionTypes2.default.OPEN_CONVERSATION_FOR_NEW_CHANNEL);

var createdContactForChannel = exports.createdContactForChannel = (0, _reduxActions.createAction)(_ActionTypes2.default.CREATED_CONTACT_FOR_CHANNEL);

function createContactForChannel(channel, _ref) {
  var email = _ref.email,
      firstName = _ref.firstName,
      lastName = _ref.lastName,
      isNewContact = _ref.isNewContact;

  return function (dispatch) {
    return MessagesClient.createContactFromVisitor({
      channel: channel,
      email: email,
      firstName: firstName,
      lastName: lastName
    }).then(function (contact) {
      dispatch(createdContactForChannel({ channel: channel, isNewContact: isNewContact }));
      dispatch(receivedVisitorForChannel(contact, channel));
    });
  };
}

function fetchAllConversations() {
  return function (dispatch) {
    dispatch(requestedConversations());
    return MessagesClient.fetchConversations().then(function (conversations) {
      dispatch(receivedConversations(conversations));
    }, function (err) {
      dispatch(requestedConversationsFailed(err));
    }).done();
  };
}


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-core/static-1.139/js/actions/ConversationsActions.js
// module id = 29
// module chunks = 0 1